import styles from './NewTabHint.module.scss';

export const NewTabHint: React.FC<{
  text?: string;
}> = ({ text = 'Öffnet ein neues Browser Tab' }) => {
  return <span className={styles.srOnly}>{text}</span>;
};
